module.exports = __webpack_public_path__ + "static/media/P20-Tip.5f634110.svg";